import React, { useState } from 'react'
import BannerImage from './images/Red-282x360.png'
import IconDefender from './images/icon_defender.svg'
import IconDeflector from './images/icon_deflector.svg'
import IconDirectAPI from './images/icon_direct_api.svg'
import './VASBanner.scss'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Box,
    Grid,
    Snackbar,
    Alert,
} from '@mui/material'

export const VASBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
    const [selectedServices, setSelectedServices] = useState<string[]>([
        'Full Service Representments',
        'Pre-Chargeback Notifications',
        'API Integration',
    ])

    const handleOpenModal = () => {
        setIsModalOpen(true)
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    const handleServiceSelect = (service: string) => {
        setSelectedServices((prev) => {
            if (prev.includes(service)) {
                return prev.filter((s) => s !== service)
            } else {
                return [...prev, service]
            }
        })
    }

    const handleInterested = () => {
        setIsConfirmationOpen(true)
        // Close the modal after a short delay to show the confirmation
        setTimeout(() => {
            setIsModalOpen(false)
        }, 100)
    }

    const handleCloseConfirmation = () => {
        setIsConfirmationOpen(false)
    }

    const isServiceSelected = (service: string) => {
        return selectedServices.includes(service)
    }

    return (
        <>
            <div
                className={'emp-VASBanner-root'}
                onClick={handleOpenModal}
                style={{ backgroundImage: `url(${BannerImage})` }}
            >
                <div className="banner-content">
                    <h1>Maximize ROI</h1>
                    <h2>Focus on running and growing your business...</h2>
                    <p>
                        While we manage the costly and time-consuming
                        chargebacks process
                    </p>
                    <button className="learn-more-btn">Learn More</button>
                </div>
            </div>

            <Dialog
                open={isModalOpen}
                onClose={handleCloseModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle className="emp-VASBanner-modal-header">
                    <Typography
                        variant="h5"
                        component="div"
                        className="emp-VASBanner-modal-title"
                    >
                        Streamline your chargeback management process by
                        enabling our comprehensive suite of solutions
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box className="emp-VASBanner-modal-content">
                        {/* <Typography variant="h5" component="div" className="emp-VASBanner-modal-subtitle">
                            Select the services you are interested in:
                        </Typography>
                         */}
                        <Grid
                            container
                            spacing={4}
                            className="emp-VASBanner-modal-grid"
                        >
                            <Grid item xs={12} md={4}>
                                <Box
                                    className={`emp-VASBanner-modal-service-container ${
                                        isServiceSelected(
                                            'Full Service Representments'
                                        )
                                            ? 'emp-VASBanner-modal-service-selected'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        handleServiceSelect(
                                            'Full Service Representments'
                                        )
                                    }
                                >
                                    <img
                                        src={IconDefender}
                                        alt="Full Service Representments"
                                        className="emp-VASBanner-modal-service-icon"
                                    />
                                    <Typography
                                        variant="h6"
                                        className="emp-VASBanner-modal-service-title"
                                    >
                                        Full Service Representments
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        className="emp-VASBanner-modal-service-description"
                                    >
                                        From prevention to representment, our
                                        dual layer approach drives more revenue
                                        recovery and proactively reduces your
                                        chargeback volume, allowing you to focus
                                        on your business
                                    </Typography>
                                    {isServiceSelected(
                                        'Full Service Representments'
                                    ) && (
                                        <Box className="emp-VASBanner-modal-service-selected-indicator">
                                            <Typography
                                                variant="body2"
                                                className="emp-VASBanner-modal-service-selected-text"
                                            >
                                                Selected
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box
                                    className={`emp-VASBanner-modal-service-container ${
                                        isServiceSelected(
                                            'Pre-Chargeback Notifications'
                                        )
                                            ? 'emp-VASBanner-modal-service-selected'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        handleServiceSelect(
                                            'Pre-Chargeback Notifications'
                                        )
                                    }
                                >
                                    <img
                                        src={IconDeflector}
                                        alt="Pre-Chargeback Notifications"
                                        className="emp-VASBanner-modal-service-icon"
                                    />
                                    <Typography
                                        variant="h6"
                                        className="emp-VASBanner-modal-service-title"
                                    >
                                        Pre-Chargeback Notifications
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        className="emp-VASBanner-modal-service-description"
                                    >
                                        Our all-in-one chargeback management
                                        system that resolves disputes and stops
                                        chargebacks before they impact your
                                        business
                                    </Typography>
                                    {isServiceSelected(
                                        'Pre-Chargeback Notifications'
                                    ) && (
                                        <Box className="emp-VASBanner-modal-service-selected-indicator">
                                            <Typography
                                                variant="body2"
                                                className="emp-VASBanner-modal-service-selected-text"
                                            >
                                                Selected
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box
                                    className={`emp-VASBanner-modal-service-container ${
                                        isServiceSelected('API Integration')
                                            ? 'emp-VASBanner-modal-service-selected'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        handleServiceSelect('API Integration')
                                    }
                                >
                                    <img
                                        src={IconDirectAPI}
                                        alt="API Integration"
                                        className="emp-VASBanner-modal-service-icon"
                                    />
                                    <Typography
                                        variant="h6"
                                        className="emp-VASBanner-modal-service-title"
                                    >
                                        API Integration
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        className="emp-VASBanner-modal-service-description"
                                    >
                                        Receive, manage, defend and query all
                                        chargebacks digitally, allowing you to
                                        increase your operational efficiencies
                                        and drive down costs
                                    </Typography>
                                    {isServiceSelected('API Integration') && (
                                        <Box className="emp-VASBanner-modal-service-selected-indicator">
                                            <Typography
                                                variant="body2"
                                                className="emp-VASBanner-modal-service-selected-text"
                                            >
                                                Selected
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>

                        <Box className="emp-VASBanner-modal-button-container">
                            <Button
                                variant="contained"
                                onClick={handleInterested}
                                className="emp-VASBanner-modal-button"
                                disabled={selectedServices.length === 0}
                            >
                                I'm Interested
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleCloseModal}
                                className="emp-VASBanner-modal-button"
                            >
                                Maybe Later
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={isConfirmationOpen}
                onClose={handleCloseConfirmation}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseConfirmation}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    An account admin will reach out to you regarding activating
                    the services selected.
                </Alert>
            </Snackbar>
        </>
    )
}

export default VASBanner
